import type React from "react";
import { useEffect, useState } from "react";
import { useApp } from "@/forApp/states/appState/appState";
import type { AllowFilterT } from "@/widgets/MainBlock/MainSearch/types";
import styles from "./styles.module.css";

type RoomSelectionProps = {
	roomsData: AllowFilterT;
	isMobile?: boolean;
};

const RoomSelection: React.FC<RoomSelectionProps> = ({
	roomsData,
	isMobile,
}) => {
	const { filters, setFilters } = useApp();
	const [roomsCount, setRoomsCount] = useState<string[]>([]);

	useEffect(() => {
		// Initialize roomsCount from filters if available
		if (filters["filters[kol-vo-komnat][]"]) {
			setRoomsCount(
				Array.isArray(filters["filters[kol-vo-komnat][]"])
					? filters["filters[kol-vo-komnat][]"]
					: [filters["filters[kol-vo-komnat][]"]],
			);
		}
	}, [filters]);

	const handleRoomChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { checked, value, name } = e.target;

		if (name.includes("[kol-vo-komnat][]")) {
			// Handle room count filters
			let newRoomsCount = [...roomsCount];

			if (checked) {
				newRoomsCount.push(value);
			} else {
				newRoomsCount = newRoomsCount.filter((room) => room !== value);
			}

			setRoomsCount(newRoomsCount);
			setFilters("filters[kol-vo-komnat][]", newRoomsCount);
		} else {
			// Handle other filters like studios, rooms, etc.
			setFilters(name, checked ? value : "");
		}
	};

	const isRoomSelected = (value: string, filter: string, name: string) => {
		if (filter === "[kol-vo-komnat]") {
			return roomsCount.includes(value);
		} else {
			return filters[`filters${filter}`] === name;
		}
	};

	return (
		<div className={styles.roomSelection}>
			<div className={isMobile ? styles.roomOptionsMobile : styles.roomOptions}>
				{roomsData.filters.map((data, index) => (
					<label
						key={index}
						className={`${isMobile ? styles.roomOptionMobile : styles.roomOption} ${isRoomSelected(data.value[0], data.filter, data.name) ? styles.roomOptionSelected : ""}`}
					>
						<input
							type="checkbox"
							name={
								data.filter === "[kol-vo-komnat]"
									? "filters[kol-vo-komnat][]"
									: `filters${data.filter}`
							}
							value={
								data.filter === "[kol-vo-komnat]" ? data.value[0] : data.name
							}
							id={`cm${data.name}`}
							checked={isRoomSelected(data.value[0], data.filter, data.name)}
							onChange={handleRoomChange}
							className={styles.roomCheckbox}
						/>
						<span className={styles.roomLabel}>{data.name}</span>
					</label>
				))}
			</div>
		</div>
	);
};

export default RoomSelection;
